import { S as Swiper } from './swiper-core-B0IA3Ohb.js';
import { M as Mousewheel } from './mousewheel-DdjXHodT.js';
import { A as A11y } from './a11y-BSOb6_-2.js';

class PredictiveSearchSuggestions extends HTMLElement {
  swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Mousewheel],
      slidesPerView: 'auto',
      spaceBetween: 24,
      slidesOffsetAfter: -24,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
    });
  }
}

customElements.define('predictive-search-suggestions', PredictiveSearchSuggestions);
